exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".item[data-v-716aa2a8]{border:1px solid #bad6db;height:240px;cursor:pointer;overflow:hidden;text-align:center}.cover[data-v-716aa2a8]{background-color:#fff;filter:Alpha(Opacity=60);opacity:.6}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-716aa2a8","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/education/educationPlan/parts/edu.vue
// module id = Vqlb
// module chunks = 0